function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #010101;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "f_eyebrowshape_hardangled_vector-2",
  "data-name": "f_eyebrowshape_hardangled_vector",
  className: "cls-2",
  d: "M331.469,271.313c9.661,0.38,36.454,6.374,39.844,12.109-0.371,3.363-1.441,7.607-3.907,8.984-6.458,2.2-29.336-9.817-36.328-11.718-7.6-2.069-17.318,3.167-23.828,4.687q0.39-.782.781-1.562Zm127.344,0c10.165-.226,22.276,8.8,27.343,14.062h-1.172c-15.65-6.085-23.162-3.353-37.89,1.172-5,1.537-14.925,6.951-20.7,5.078-2.925-1.363-4.133-6.182-3.516-9.766C430.171,273.342,448.251,276.747,458.813,271.313Z"
});

var SvgFEyebrowshapeHardangledVector = function SvgFEyebrowshapeHardangledVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_eyebrowshape_hardangled_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFEyebrowshapeHardangledVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_eyebrowshape_hardangled_vector.6f63b74f.svg";
export { ForwardRef as ReactComponent };